// extracted by mini-css-extract-plugin
export default {"formHeading":"xI-z","form":"yI-z","submitBtn":"zI-z","disabled":"AI-z","input":"BI-z","error":"CI-z","submitMsg":"DI-z","signIn":"EI-z"};